import React, { FC, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { i18n } from '../../../i18n';

import { useAppContext } from '../../../context/AppContext';

import './result.scss';

const getTextTransform = (
  caseValue?: string
): 'none' | 'capitalize' | 'uppercase' | 'lowercase' => {
  return ['none', 'capitalize', 'uppercase', 'lowercase'].includes(
    caseValue || ''
  )
    ? (caseValue as 'none' | 'capitalize' | 'uppercase' | 'lowercase')
    : 'none';
};

interface IPropsResult {
  gender: string | undefined;
  restart: () => void;
  recommendedSize?: any;
}

const closeIframe = () =>
  window.parent.postMessage({ action: 'closeIframe' }, '*');
const sendMid = () =>
  window.parent.postMessage(
    { data: 'mid', mid: localStorage.getItem('mid') },
    '*'
  );
const clearMid = () => window.parent.postMessage({ action: 'clearMid' }, '*');

const Result: FC<IPropsResult> = ({
  gender,
  restart,
  recommendedSize
}) => {
  const appContext = useAppContext() || undefined;

  const findOtherSize = (
    domain: string,
    product_id: string,
    rank_1: string,
    rank_2: string
  ): string => {
    if (domain === 'getkleep-sessun.myshopify.com' && product_id !== '9823788138807') {
      if (product_id === '9823573868855') return 'otherSize_up';
      else if (product_id === '9823793676599') return 'otherSize_down';
      else if (product_id === '9823750127927') return 'otherSize_up';
      else if (product_id === '9823782338871') return 'otherSize_down';
      else return '';
    } else {
      return rank_1 > rank_2
      ? 'otherSize_down'
      : domain === 'www.chlore-swimwear.fr'
        ? 'otherSize_up_swimwear'
        : 'otherSize_up';
    }
  };
  const findOtherIndex = (label: string): number => {
    if (label === 'otherSize_up') {
      if (recommendedSize[1].label_rank === 2) return 1;
      else return 2;
    } else if (label === 'otherSize_down') {
      if (recommendedSize[1].label_rank === 0) return 1;
      else return 2;
    }
    return 0;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const domain = urlParams.get('domain') || '';
  const product_id = urlParams.get('product_id') || '';
  const otherSize = findOtherSize(domain, product_id, recommendedSize[0].label_rank, recommendedSize[1].label_rank)
  let otherIndex = 1;
  if (domain === 'getkleep-sessun.myshopify.com') {
    otherIndex = Math.min(findOtherIndex(otherSize),recommendedSize.length - 1);
  }
  console.log(otherSize);
  const results = [
    {
      size: recommendedSize[0].label,
      pvid: recommendedSize[0].variant_id
    },
    {
      size: recommendedSize[otherIndex].label,
      pvid: recommendedSize[otherIndex].variant_id
    }
  ];

  const { t } = useTranslation('components/results/result');
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    sendMid();
  }, []);

  return (
    <div className="result">
      <p
        className={`result__size result__size--${
          results[activeIndex].size.length > 5 ? 'reduce' : 'full'
        } result__size--available`}
        style={{
          textTransform:
            getTextTransform(appContext?.style?.cta?.case) === 'lowercase'
              ? 'lowercase'
              : 'uppercase'
        }}
      >
        {results[activeIndex].size}
      </p>
      <div className="result__list">
        {results.map((result, index) => {
          if (result.size === '-') return null;
          else {
            return (
              <div
                className={`result__list__card ${
                  index === activeIndex
                    ? 'result__list__card--active'
                    : results[index].size !== '-'
                      ? 'result__list__card--inactive'
                      : 'result__list__card--disabled'
                }`}
                style={{
                  textTransform:
                    getTextTransform(appContext?.style?.cta?.case) ===
                    'lowercase'
                      ? 'lowercase'
                      : 'none'
                }}
                onClick={() => {
                  if (results[index].size !== '-') {
                    setActiveIndex(index);
                  }
                }}
                key={index}
              >
                <div className="result__list__card__selector">
                  {index === activeIndex ? (
                    <div className="result__list__card__selector__child" />
                  ) : null}
                </div>
                <div className="result__list__card__content">
                  <div className="result__list__card__content__header">
                    <p className="result__list__card__content__header__size">
                      {result.size}
                    </p>
                    {index === 0 && (
                      <p className="result__list__card__content__header__satisfaction">
                        {t('size')}
                      </p>
                    )}
                    {index === 1 && results[0].size !== results[1].size && (
                      <p className="result__list__card__content__header__satisfaction">
                        {t(otherSize)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
      {recommendedSize?.availability !== 2 ? (
        <div className="result__text">
          <p
            className="result__text__description"
            style={{
              textTransform:
                getTextTransform(appContext?.style?.cta?.case) === 'lowercase'
                  ? 'lowercase'
                  : 'none'
            }}
          >
            <Trans
              ns="components/results/result"
              i18nKey="description"
              values={{
                gender:
                  i18n.language.split('-')[0] === 'fr'
                    ? gender === 'male'
                      ? 's'
                      : 's'
                    : i18n.language.split('-')[0] === 'de'
                      ? gender === 'male'
                        ? 'en'
                        : 'innen'
                      : null,
                size: results[0].size
              }}
            />
          </p>
        </div>
      ) : (
        <div className="result__text">
          <p className="result__text__fail">{t('fail')}</p>
        </div>
      )}
      <div className="result__buttons">
        {recommendedSize?.availability !== 1 ? (
          <button
            onClick={() => {
              const mid = localStorage.getItem('mid') || '';
              console.log('Variant added to cart:', results[activeIndex].pvid);
              window.parent.postMessage(
                { action: 'addToCart', variantId: results[activeIndex].pvid },
                '*'
              );
              sendMid();
              closeIframe();
            }}
            className="result__buttons__save"
            style={{
              textTransform: getTextTransform(appContext?.style?.cta?.case)
            }}
          >
            <Trans
              ns="components/results/result"
              i18nKey="cart"
              values={{ size: results[activeIndex].size }}
            />
          </button>
        ) : null}
        <div className="result__buttons__text">
          <button
            className="result__buttons__text__restart"
            onClick={() => {
              clearMid();
              restart();
            }}
            style={{
              textTransform:
                getTextTransform(appContext?.style?.cta?.case) === 'lowercase'
                  ? 'lowercase'
                  : 'none'
            }}
          >
            {t('restart')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Result;
